export enum SpecialContentHandler {
  EventDetail = "event-detail",
  JobDetail = "job-detail",
  RequestInfoForm = "request-info-form",
  RequestDemoForm = "request-demo-form",
  RequestSupportForm = "request-support-form",
  NewsletterForm = "newsletter-form",
  CustomerStoriesList = "customer-stories-list",
  ExhibitionFinder = "exhibition-finder",
  WhatsNextFinder = "whats-next-finder",
  StoreLocator = "store-locator",
  CookieDeclaration = "cookie-declaration",
}
